import React from 'react'
import LesaRouter from './components/general/LesaRouter'
const App = () => {
  return (
    <LesaRouter/>
  )
}

export default App
